/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Askquestion_Placeholder2Inputs */

const en_coinvestments_messages_askquestion_placeholder2 = /** @type {(inputs: Coinvestments_Messages_Askquestion_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your question or message...`)
};

/**
* | output |
* | --- |
* | "Type your question or message..." |
*
* @param {Coinvestments_Messages_Askquestion_Placeholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_askquestion_placeholder2 = /** @type {((inputs?: Coinvestments_Messages_Askquestion_Placeholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Askquestion_Placeholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_askquestion_placeholder2(inputs)
});
export { coinvestments_messages_askquestion_placeholder2 as "coInvestments_messages_askQuestion_placeholder" }